import { render, staticRenderFns } from "./bulk-stock-allocation.vue?vue&type=template&id=1a5eb9ed"
import script from "./bulk-stock-allocation.vue?vue&type=script&lang=js"
export * from "./bulk-stock-allocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports